<template>
  <div class="barChart">
    <div class="sort-by">
      <!-- <h3>Customer Categories</h3> -->

      <div class="dropdown">
        <div class="dropdown-trigger" @click="toggleDropdown">
          {{ selectedType ? selectedType.label : "Select Terminal Type" }}
          <span class="arrow" :class="{ open: isOpen }">▼</span>
        </div>

        <ul v-if="isOpen" class="menu">
          <li
            v-for="option in barChartOptions"
            :key="option.value"
            @click="selectOption(option)"
            :class="{
              active: selectedType && selectedType.value === option.value,
            }"
          >
            {{ option.label }}
          </li>
        </ul>
      </div>

      <div class="col-4 m-0">
        <select class="form-control" v-model="sortOrder" @change="buildChart">
          <option value="asc">Sort By: Ascending</option>
          <option value="desc">Sort By: Descending</option>
        </select>
      </div>
    </div>
    <div class="chart-wrapper" style="overflow-y: auto; height: 400px">
      <div
        ref="barChart"
        class="ct-chart ct-golden-section bar-chart-container"
      ></div>
    </div>
  </div>
</template>

<script>
import Chartist from "chartist";
import axios from "../store/axios";

export default {
  name: "HorizontalBarChart",

  data() {
    return {
      customerCategories: [],
      loading: false,
      sortOrder: "desc",
      isOpen: false,
      selectedType: {
        label: "Agent Category",
        value: "customerCategory",
        key: "merchant",
      },
      barChartOptions: [
        {
          label: "Agent Category",
          value: "customerCategory",
          key: "merchant",
        },
        { label: "Agent State", value: "customerState", key: "state" },
        { label: "Agent Name", value: "customerName", key: "agent" },
      ],
    };
  },

  methods: {
    async getCustomerCategories() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/group/terminals?groupBy=${this.selectedType.key}`,
        );
        console.log(
          "customerCategories switch",
          `${process.env.VUE_APP_API_URL}/analytics/group/terminals?groupBy=${this.selectedType.key}`,
        );
        console.log("customerCategories", res.data.data);

        this.customerCategories = res.data.data;
        this.buildChart();

        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    buildChart() {
      console.log("Building bar chart...");

      let sortedCategories = [...this.customerCategories];
      console.log("sortedCategories", sortedCategories);

      // sort by count
      sortedCategories.sort((a, b) => {
        return this.sortOrder === "asc" ? a.count - b.count : b.count - a.count;
      });

      console.log("sortedCategories", sortedCategories);

      const labels = sortedCategories.map((c) => c.label);
      const series = [sortedCategories.map((c) => c.count)];

      const dynamicHeight = labels.length * 50;
      this.$refs.barChart.style.height = `${dynamicHeight}px`;

      new Chartist.Bar(
        this.$refs.barChart,
        {
          labels,
          series,
        },
        {
          seriesBarDistance: 15,
          reverseData: true, // show top to bottom
          horizontalBars: true, // horizontal bars
          axisY: {
            offset: 100, // more space for labels
          },
          axisX: {
            onlyInteger: true, // whole numbers only
          },
        },
      );
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    async selectOption(option) {
      this.selectedType = option;
      this.isOpen = false;
      await this.getCustomerCategories();
    },
  },

  async mounted() {
    await this.getCustomerCategories();
  },
};
</script>

<style scoped>
.sort-by {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sort-by h3 {
  margin: 0;
  color: black;
  width: fit-content;
  font-weight: 600;
  font-size: 28px;
}

/* .chart-wrapper {
  width: 100%;
  height: 300px;
} */

/* Rounded colorful bars */
.ct-series-a .ct-bar {
  stroke: #36a2eb;
  stroke-width: 20px;
  stroke-linecap: round;
}

.chartist-tooltip {
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  white-space: nowrap;
}

.barChart {
  background: white;
  padding: 16px;
  border-radius: 8px;
  height: 100%;
  width: 50%;
}

.bar-chart-container {
  width: 100%;
  max-height: 500px;
  /* overflow-y: scroll; */
}

.dropdown {
  position: relative;
  width: 100%;
  margin: 8px 0;
}

.dropdown-trigger {
  color: black;
  width: fit-content;
  font-weight: 600;
  font-size: 27px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}

.arrow {
  float: right;
  transition: transform 0.2s;
}
.arrow.open {
  transform: rotate(180deg);
}

ul {
  list-style: none;
}
.menu {
  position: absolute;
  width: 100%;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 6px;
  margin-top: 2px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 100;
}
.menu li {
  padding: 8px 10px;
  cursor: pointer;
}
.menu li:hover,
.menu li.active {
  background: #f0f0f0;
}
</style>
